export default __webpack_public_path__ + "static/media/vampirewake.73d0e028.mp3";